export var EverGiveSharePercentageVariants;
(function (EverGiveSharePercentageVariants) {
    EverGiveSharePercentageVariants["control"] = "control";
    EverGiveSharePercentageVariants["variant"] = "variant";
})(EverGiveSharePercentageVariants || (EverGiveSharePercentageVariants = {}));
export var EverGiveContentVariants;
(function (EverGiveContentVariants) {
    EverGiveContentVariants["control"] = "controlled-make-your-rewards";
    EverGiveContentVariants["variant"] = "variant-become-an-EverGiver";
})(EverGiveContentVariants || (EverGiveContentVariants = {}));
export var GiveMatchLogoVariants;
(function (GiveMatchLogoVariants) {
    GiveMatchLogoVariants["withLogo"] = "withLogo";
    GiveMatchLogoVariants["noLogo"] = "noLogo";
})(GiveMatchLogoVariants || (GiveMatchLogoVariants = {}));
export var ActiveExperiments;
(function (ActiveExperiments) {
    ActiveExperiments["EverGiveSharePercentage"] = "EverGiveSharePercentage";
    ActiveExperiments["EverGiveContentVariants"] = "EverGiveContentVariants";
    ActiveExperiments["GiveMatchLogo"] = "GiveMatchLogo";
})(ActiveExperiments || (ActiveExperiments = {}));
export const defaultVariants = {
    EverGiveSharePercentage: {
        [EverGiveSharePercentageVariants.control]: 100,
        [EverGiveSharePercentageVariants.variant]: 100
    },
    EverGiveContentVariants: {
        [EverGiveContentVariants.control]: 100,
        [EverGiveContentVariants.variant]: 100
    },
    GiveMatchLogo: {
        [GiveMatchLogoVariants.withLogo]: 100,
        [GiveMatchLogoVariants.noLogo]: 100
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3BsaXR0ZXN0aW5nLmpzIiwic291cmNlUm9vdCI6InNyYy8iLCJzb3VyY2VzIjpbInNwbGl0VGVzdGluZy9zcGxpdHRlc3RpbmcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxDQUFOLElBQVksK0JBR1g7QUFIRCxXQUFZLCtCQUErQjtJQUN6QyxzREFBbUIsQ0FBQTtJQUNuQixzREFBbUIsQ0FBQTtBQUNyQixDQUFDLEVBSFcsK0JBQStCLEtBQS9CLCtCQUErQixRQUcxQztBQUVELE1BQU0sQ0FBTixJQUFZLHVCQUdYO0FBSEQsV0FBWSx1QkFBdUI7SUFDakMsbUVBQXdDLENBQUE7SUFDeEMsa0VBQXVDLENBQUE7QUFDekMsQ0FBQyxFQUhXLHVCQUF1QixLQUF2Qix1QkFBdUIsUUFHbEM7QUFFRCxNQUFNLENBQU4sSUFBWSxxQkFHWDtBQUhELFdBQVkscUJBQXFCO0lBQy9CLDhDQUFxQixDQUFBO0lBQ3JCLDBDQUFpQixDQUFBO0FBQ25CLENBQUMsRUFIVyxxQkFBcUIsS0FBckIscUJBQXFCLFFBR2hDO0FBRUQsTUFBTSxDQUFOLElBQVksaUJBSVg7QUFKRCxXQUFZLGlCQUFpQjtJQUMzQix3RUFBbUQsQ0FBQTtJQUNuRCx3RUFBbUQsQ0FBQTtJQUNuRCxvREFBK0IsQ0FBQTtBQUNqQyxDQUFDLEVBSlcsaUJBQWlCLEtBQWpCLGlCQUFpQixRQUk1QjtBQUVELE1BQU0sQ0FBQyxNQUFNLGVBQWUsR0FBb0I7SUFDOUMsdUJBQXVCLEVBQUU7UUFDdkIsQ0FBQywrQkFBK0IsQ0FBQyxPQUFPLENBQUMsRUFBRSxHQUFHO1FBQzlDLENBQUMsK0JBQStCLENBQUMsT0FBTyxDQUFDLEVBQUUsR0FBRztLQUMvQztJQUNELHVCQUF1QixFQUFFO1FBQ3ZCLENBQUMsdUJBQXVCLENBQUMsT0FBTyxDQUFDLEVBQUUsR0FBRztRQUN0QyxDQUFDLHVCQUF1QixDQUFDLE9BQU8sQ0FBQyxFQUFFLEdBQUc7S0FDdkM7SUFDRCxhQUFhLEVBQUU7UUFDYixDQUFDLHFCQUFxQixDQUFDLFFBQVEsQ0FBQyxFQUFFLEdBQUc7UUFDckMsQ0FBQyxxQkFBcUIsQ0FBQyxNQUFNLENBQUMsRUFBRSxHQUFHO0tBQ3BDO0NBQ0YsQ0FBQSJ9